class ArticleNavigation extends HTMLElement {
  connectedCallback() {
    this.articleCards = document.querySelectorAll('[data-article-card]');
    this.tagButtons = this.querySelectorAll('[data-tag]');
    this.tagButtons.forEach((button) => {
      button.addEventListener('click', (e) => this.handleTagClick(e));
    });

    window.addEventListener('popstate', (e) => this.handlePopState(e));
    this.initializeFromUrl();
  }

  getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return params.get('tag') || 'all';
  }

  updateUrl(tag) {
    const url = new URL(window.location);

    if (tag === 'all') {
      url.searchParams.delete('tag');
    } else {
      url.searchParams.set('tag', tag);
    }

    window.history.pushState({ tag }, '', url);
  }

  initializeFromUrl() {
    const tag = this.getUrlParams();
    const button = this.querySelector(`[data-tag="${tag}"]`);

    if (button) {
      this.updateActiveState(button);
      this.filterArticles(tag);
    }
  }

  handlePopState(event) {
    const tag = event.state?.tag || this.getUrlParams();
    const button = this.querySelector(`[data-tag="${tag}"]`);

    if (button) {
      this.updateActiveState(button);
      this.filterArticles(tag);
    }
  }

  handleTagClick(event) {
    const button = event.target.closest('[data-tag]');
    if (!button) return;

    const tag = button.dataset.tag;

    this.updateActiveState(button);
    this.filterArticles(tag);
    this.updateUrl(tag);
  }

  filterArticles(tag) {
    this.articleCards.forEach((card) => {
      const shouldShow = tag === 'all' || this.cardHasTag(card, tag);
      card.classList.toggle('hidden', !shouldShow);
    });
  }

  cardHasTag(card, tag) {
    const tags = (card.dataset.articleTags || '').split(',').map((t) => t.trim());
    return tags.includes(tag);
  }

  updateActiveState(activeButton) {
    this.tagButtons.forEach((btn) => btn.classList.remove('active'));
    activeButton.classList.add('active');
  }
}

if (!customElements.get('article-navigation')) {
  customElements.define('article-navigation', ArticleNavigation);
}
